__webpack_require__.p = "https://cnumetahub.jnu.ac.kr:8080/";